//
//
//
//
//
//
//

export default {
    name: "ModuleTitle",
  props:{
    title:{
      type:String,
      default:""
    },
    linkId:{
      type:Boolean,
      default:true
    }
  },
  methods:{
      // sendToggleType(){
      //   this.$emit('sendToggleType',this.linkId)
      // }
  }
}



// WEBPACK FOOTER //
// ./src/pccomponents/ModuleTitle.vue